require("./components/min");

window.Vue = require("vue");
window.Vapor = require("laravel-vapor");

Vue.component(
  "crop-upload",
  require("../components/CropUploadComponent.vue").default
);

Vue.component(
  "crop-parent-form",
  require("../components/CropParentFormComponent.vue").default
);

new Vue({ el: "#app" });
